import LdGatedButton from 'lion-vue-src/Shared/components/LdFeatureGate/LdGatedButton';
export default LdGatedButton;